import { publishViewOfferPaywallEvent } from "../../../screens/root/api/eventsApi";
import { useGetNavigationContext } from "../../../hooks/useGetNavigationContext";
import { Flex, Box, Button } from "@chakra-ui/react";
import { useRef, useEffect } from "react";
import { useTopBarHeight } from "../../../hooks/userTopBarHeight";
import { useIsSmallBreakpoint } from "../../../utils/useBreakpoints";
import {
  FunnelComponentProps,
  FunnelContextArea,
  EventContextArea,
  FunnelNavigationContext,
  funnelToEventContextArea,
} from "../../funnel/types";
import { FUNNEL_TYPES } from "../../funnel/utils/contants";

export function OfferPaywallModalBody({
  onSuccess,
  setFunnelType,
  updateFunnelConfig,
  modalContext,
  navigationContext,
  assetUrl,
}: FunnelComponentProps & {
  assetUrl?: string;
  navigationContext?: FunnelNavigationContext;
}) {
  const isSmallBreakpoint = useIsSmallBreakpoint();

  const eventSentRef = useRef(false);

  // Use passed navigationContext if available, otherwise create new one
  const currentNavigationContext =
    navigationContext ||
    useGetNavigationContext({
      contextArea: funnelToEventContextArea(modalContext, EventContextArea.offerPaywall),
    });

  useEffect(() => {
    if (!eventSentRef.current) {
      publishViewOfferPaywallEvent(currentNavigationContext);
      eventSentRef.current = true;
    }
  }, [currentNavigationContext]);

  const handleContinue = () => {
    // Use requestAnimationFrame to ensure transition happens after current render cycle
    requestAnimationFrame(() => {
      if (updateFunnelConfig) {
        updateFunnelConfig({
          type: FUNNEL_TYPES.subscription,
          context: {
            modalContext,
            navigationContext: currentNavigationContext,
          },
          options: {
            onSuccess,
            skipOfferPaywallModal: true,
          },
        });
      } else if (setFunnelType) {
        setFunnelType(FUNNEL_TYPES.subscription);
      }
    });
  };

  const htmlUrl = `${window.gc.global.assets_url}${assetUrl}`;

  const isDetailsContext = modalContext === FunnelContextArea.releaseDetails;
  const headerPadding = isDetailsContext ? 75 : 0;
  const topBarHeight = useTopBarHeight();

  const menuHeight = isSmallBreakpoint
    ? "100dvh"
    : `100dvh - ${topBarHeight.get()}px - 25px`;
  return (
    <Flex
      position="relative"
      direction="column"
      width="100%"
      overflow="hidden"
      borderRadius="16px"
    >
      <iframe
        src={htmlUrl}
        width="100%"
        height={isSmallBreakpoint || isDetailsContext ? "5000px" : "700px"}
        style={{
          border: "none",
          zIndex: 0,
          maxHeight: `calc(${menuHeight} - 96px - ${headerPadding}px)`,
        }}
      />

      <Box
        width="100%"
        height="96px"
        zIndex={1}
        bg="charcoal.charcoal"
        padding="24px"
        paddingBottom={{
          base: "max(24px, env(safe-area-inset-bottom))",
          md: "24px",
        }}
      >
        <Button
          gc-testing-id="btnContinueOfferPaywall"
          variant="primary"
          size="lg"
          width="100%"
          onClick={handleContinue}
        >
          Continue
        </Button>
      </Box>
    </Flex>
  );
}
